module.exports = __webpack_public_path__ + "static/media/class_list2_bg.33fbb0c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/class_list2_bg.jpg
// module id = 1577
// module chunks = 10